import { render, staticRenderFns } from "./abiltityManage.vue?vue&type=template&id=45bf0d2e&"
import script from "./abiltityManage.vue?vue&type=script&lang=js&"
export * from "./abiltityManage.vue?vue&type=script&lang=js&"
import style0 from "./abiltityManage.vue?vue&type=style&index=0&id=45bf0d2e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports